import { render } from "./ProductionOrderDetails.vue?vue&type=template&id=4a73d701&scoped=true"
import script from "./ProductionOrderDetails.vue?vue&type=script&lang=js"
export * from "./ProductionOrderDetails.vue?vue&type=script&lang=js"

import "./ProductionOrderDetails.vue?vue&type=style&index=0&id=4a73d701&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LYRASHOES/mi-stock-lyrashoes-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a73d701"]])

export default __exports__